import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import { withErrorBoundary } from 'react-error-boundary';
import ComponentError from 'components/Error/ComponentError';
import { handleError } from 'services/ErrorService';

import './styles.scss';
import { Radio } from '@patternfly/react-core';
import { PremiumSessionUserFacingStatus } from 'types/premiumSession';

type Props = {
  amount?: number;
  available?: number;
  attended?: number;
  interested?: number;
  scheduled?: number;
  selectedStatus?: PremiumSessionUserFacingStatus;
  setSelectedStatus?: (status: PremiumSessionUserFacingStatus) => void;
  unavailable?: number;
};

const PremiumSessionLegends = ({
  amount,
  attended,
  interested,
  available,
  scheduled,
  selectedStatus,
  setSelectedStatus,
  unavailable,
}: Props) => (
  <div className="premium-session-legends">
    {amount !== undefined && (
      <Radio
        className="premium-session-legends__radio"
        isChecked={!selectedStatus}
        name="status-filter"
        isDisabled={!amount}
        onChange={() => setSelectedStatus(undefined)}
        label={<Trans values={{ amount }}>All sessions: {{ amount }}</Trans>}
        id="status-filter-all"
      />
    )}
    {available !== undefined && (
      <Radio
        className="premium-session-legends__radio"
        isChecked={
          selectedStatus === PremiumSessionUserFacingStatus.Schedulable
        }
        name="status-filter"
        isDisabled={!available}
        onChange={() =>
          setSelectedStatus(PremiumSessionUserFacingStatus.Schedulable)
        }
        label={<Trans values={{ available }}>Available: {{ available }}</Trans>}
        id="status-filter-available"
      />
    )}
    {scheduled !== undefined && (
      <Radio
        className="premium-session-legends__radio"
        isChecked={selectedStatus === PremiumSessionUserFacingStatus.Enrolled}
        name="status-filter"
        isDisabled={!scheduled}
        onChange={() =>
          setSelectedStatus(PremiumSessionUserFacingStatus.Enrolled)
        }
        label={<Trans values={{ scheduled }}>Scheduled: {{ scheduled }}</Trans>}
        id="status-filter-scheduled"
      />
    )}
    {attended !== undefined && (
      <Radio
        className="premium-session-legends__radio"
        isChecked={selectedStatus === PremiumSessionUserFacingStatus.Attended}
        name="status-filter"
        isDisabled={!attended}
        onChange={() =>
          setSelectedStatus(PremiumSessionUserFacingStatus.Attended)
        }
        label={<Trans values={{ attended }}>Attended: {{ attended }}</Trans>}
        id="status-filter-attended"
      />
    )}
    {interested !== undefined && (
      <Radio
        className="premium-session-legends__radio"
        isChecked={selectedStatus === PremiumSessionUserFacingStatus.Requested}
        name="status-filter"
        isDisabled={!interested}
        onChange={() =>
          setSelectedStatus(PremiumSessionUserFacingStatus.Requested)
        }
        label={
          <Trans values={{ interested }}>Requested: {{ interested }}</Trans>
        }
        id="status-filter-interested"
      />
    )}
    {unavailable !== undefined && (
      <Radio
        className="premium-session-legends__radio"
        isChecked={
          selectedStatus === PremiumSessionUserFacingStatus.Unavailable
        }
        name="status-filter"
        isDisabled={!unavailable}
        onChange={() =>
          setSelectedStatus(PremiumSessionUserFacingStatus.Unavailable)
        }
        label={
          <Trans values={{ unavailable }}>Unavailable: {{ unavailable }}</Trans>
        }
        id="status-filter-unavailable"
      />
    )}
  </div>
);

export default withErrorBoundary(
  observer(PremiumSessionLegends),
  ComponentError,
  handleError,
);
